<script setup lang="ts">
import type { Component } from 'vue';

const props = defineProps<{
    title: string;
    description: string;
    icon: Component;
    isCurrentPlan?: boolean;
}>();
</script>

<template>
    <div class="card-header space-y-2">
        <div class="flex items-center justify-between gap-2">
            <p class="inline-flex items-center gap-2 text-sm font-semibold">
                <component :is="props.icon" class="h-4 w-4" />
                {{ props.title }}
            </p>
            <p
                v-if="props.isCurrentPlan"
                class="subscription-tag rounded-full bg-foreground text-background px-2 py-1 text-[10px] font-medium"
            >
                Current plan
            </p>
        </div>
        <p class="text-sm text-muted-foreground">
            {{ props.description }}
        </p>
    </div>
</template>
